$(document).ready(function(){
  const MegaMenuList = document.querySelector("#Shop-MegaMenu");
  const MMListItem = MegaMenuList.querySelectorAll("li");
  const MmTabsContent = document.querySelectorAll(".megamenu-tabcontent");

  MMListItem.forEach((listItem) => {
    listItem.addEventListener("click", function() {
      var divID = listItem.getAttribute('data-href').toString();
      for (let el of MmTabsContent) el.style.display = 'none';
      for (let el of MMListItem) el.classList.remove("active");
      document.getElementById(divID).style.display = "block";
      listItem.classList.add("active");
    });
  });
});
